
try {

(function(win, $async) {

    // requestAnimationFrame
    var RAF = win.RAF = function(callback, frame) {
        var cfg;
        if (frame) {
            cfg = {
                type: "requestAnimationFrame",
                frame, frame
            };
        } else {
            cfg = 'requestAnimationFrame';
        }
        $async.time(cfg, callback);
    };

    // requestIdleCallback
    win.IDLE = function(callback, timeout) {
        var cfg;
        if (timeout) {
            cfg = {
                type: "requestIdleCallback",
                timeout: timeout
            };
        } else {
            cfg = 'requestIdleCallback';
        }
        $async.time(cfg, callback);
    };

    var owl_loaded, owl_loading, owl_queue = [];
    win.load_owl = function(cb) {
        function resolve() {
            if (cb) {
                RAF(function(){
                    cb();

                    var qcb;
                    while (qcb = owl_queue.shift()) {
                        qcb();
                    }
                });
            }
        }
        if (owl_loading) {
            owl_queue.push(cb);
        } else if (owl_loaded) {
            resolve();
        } else {
            owlcss();
            owljs().then(resolve);
        }
    };

})(window, $async)
} catch(e){_st_catch(e)}
